export default "__VITE_ASSET__D1$jP9zv__"